import dayjs from "dayjs";
import { useField } from "formik";
import SingleDatePicker from "../../../../components/Forms/SingleDatePicker";

export default function AssetPositionAssetLinkDateSelect(props: {
  serial_number?: string;
  customerReference?: string;
  newLink?: boolean;
}) {
  const { serial_number, customerReference } = props;
  const [installDate] = useField("install_date");
  const [uninstallDate] = useField("uninstall_date");

  const installDateText = installDate.value
    ? `${dayjs(installDate.value).format("dddd D MMMM YYYY")} 00:00:00`
    : "forever";
  const uninstallDateText = uninstallDate.value
    ? `${dayjs(uninstallDate.value)
        .subtract(1, "days")
        .format("dddd D MMMM YYYY")} 23:59:59`
    : "forever";

  return (
    <>
      <h4>Installed</h4>
      <SingleDatePicker
        dateName={"install_date"}
        showPresets={false}
        placeholder={"Forever"}
        timeZone={"Europe/London"}
        useStringValues={true}
      />
      <h4>Uninstalled</h4>
      <SingleDatePicker
        dateName={"uninstall_date"}
        showPresets={false}
        placeholder={"Forever"}
        timeZone={"Europe/London"}
        useStringValues={true}
        minDate={installDate.value ? dayjs(installDate.value) : undefined}
        maxDate={dayjs().endOf("day")}
      />
      {props.newLink ? (
        <>
          Data for new asset with be used from {installDateText} till{" "}
          {uninstallDateText}.
        </>
      ) : (
        <>
          {" "}
          Data from {serial_number} will be used for position{" "}
          {customerReference} from {installDateText} till {uninstallDateText}.
        </>
      )}
    </>
  );
}
